import React from 'react'
import firebase from './../Firestore'


class Adicionales extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      adicionales: [],
      AdicionalesSeleccionados: [],
      AdicionalNombrePrecioSeleccionado: []
     };
  }


  componentDidUpdate(prevProps){
    if (this.props.categoriaId !== prevProps.categoriaId) {
      var db = firebase.firestore();
      db.collection("adicionales").where("categoriaID", "==", this.props.categoriaId).get().then((snapShots) => {
            this.setState(
              {
                adicionales: snapShots.docs.map(doc => {
                  return {
                    "nombre": doc.data().nombre,
                    "precio": doc.data().precio,
                    "id": doc.id
                  }
                })
              }
            );
      });
    }
  }


  onChange(event) {
      let AdicionalesSeleccionados = this.state.AdicionalesSeleccionados
      let AdicionalNombrePrecioSeleccionado = this.state.AdicionalNombrePrecioSeleccionado
      if(event.target.checked){

        AdicionalesSeleccionados.push(event.target.id);
        AdicionalNombrePrecioSeleccionado.push({"nombre": event.target.name, "precio": event.target.value})


        this.setState({ AdicionalesSeleccionados: AdicionalesSeleccionados,
          AdicionalNombrePrecioSeleccionado: AdicionalNombrePrecioSeleccionado
         })

      } else{

        let pos = AdicionalesSeleccionados.indexOf(event.target.id);

        if(pos > -1) {
          AdicionalesSeleccionados.splice(pos,1);
          AdicionalNombrePrecioSeleccionado.splice(pos,1);

          this.setState({ AdicionalesSeleccionados: AdicionalesSeleccionados,
            AdicionalNombrePrecioSeleccionado: AdicionalNombrePrecioSeleccionado})
        }



      }

      this.props.adicionalesSeleccionados(AdicionalesSeleccionados, AdicionalNombrePrecioSeleccionado);

  }


  render() {

    const classOpcionSeleccionada = "col custom-control custom-checkbox form-check-inline badge badge-pill mb-2";
    const classOpcionNoSeleccionada = "col custom-control custom-checkbox form-check-inline badge badge-pill mb-2";


    if(this.state.adicionales.length > 0) {
      const Items = this.state.adicionales.map((todo) =>
          <div key={todo.id} className={this.state.AdicionalesSeleccionados.indexOf(todo.id) === 0 ? classOpcionSeleccionada : classOpcionNoSeleccionada}>
              <input type="checkbox" name={todo.nombre} value={todo.precio} id={todo.id} onChange={event => this.onChange(event)} className="custom-control-input" checked={this.state.AdicionalesSeleccionados.indexOf(todo.id) > -1 ? true : false}/>
              <label className="custom-control-label" htmlFor={todo.id}><span className="badge badge-pill badge-warning">{todo.nombre}</span><br/><span className="precio">$ {todo.precio}</span></label>
        </div>
      );



      return (
        <div className="bg-light mb-0 mx-3 rounded border border-dark text-center">
              <span className="mt-0 ml-0 p-0"><small>Adicionales</small></span>
              <div className="container">
              <div className="row d-flex flex-wrap p-2">
                {Items}
              </div>
            </div>
        </div>
      )

    }else{
      return ""
    }

  }
}

export default Adicionales
